import React from 'react';
import { useExperienceFail } from '@atlassian/jira-experience-tracker/src/ui/experience-fail/index.tsx';
import { ExperienceStart } from '@atlassian/jira-experience-tracker/src/ui/experience-start/index.tsx';
import { ExperienceSuccess } from '@atlassian/jira-experience-tracker/src/ui/experience-success/index.tsx';
import { JIRA_SOFTWARE } from '@atlassian/jira-shared-types/src/application.tsx';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';

const EXPERIENCE_NAME = 'viewVersionsPage';
const ANALYTICS_SOURCE = 'versions';

export const JiraProjectVersionExperienceStart = ({
	experienceId,
}: {
	experienceId: string;
}): React.JSX.Element => {
	const appEditions = useAppEditions();
	return (
		<ExperienceStart
			experienceId={experienceId}
			experience={EXPERIENCE_NAME}
			analyticsSource={ANALYTICS_SOURCE}
			edition={appEditions.software}
			application={JIRA_SOFTWARE}
		/>
	);
};
export const JiraProjectVersionExperienceSuccess = (): React.JSX.Element => (
	<ExperienceSuccess experience={EXPERIENCE_NAME} attributes={{ isLegacy: false }} />
);

export const JiraProjectVersionExperienceExpectedFailureSuccess = ({
	reason,
}: {
	reason: string;
}): React.JSX.Element => (
	<ExperienceSuccess
		experience={EXPERIENCE_NAME}
		attributes={{ isLegacy: false, expectedFailureReason: reason }}
	/>
);

export const useJiraProjectVersionExperienceFail = () =>
	useExperienceFail({
		experience: EXPERIENCE_NAME,
		attributes: { isLegacy: false },
	});
